import { useState, useContext } from "react";
import { MdDelete, MdModeEdit } from "react-icons/md";
import { IconButton, Stack, Box, Tooltip } from "@mui/material";
import { IoMdEye } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import { useMutation } from "@apollo/client";
//Import from project
import "../../../../Style/actionstyle.scss";
import { AuthContext } from "../../../../Context/AuthContext";
import ExamTypeForm from "./ExamTypeForm";
import DialogDelete from "../../../../Utils/DialogDelete";
import { DELETE_EXAM_TYPE } from "../../../../Schema/ExamType";

export default function ExamTypeAction({ editData, setRefetch }) {
  // Change Language
  const { t, setAlert } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);

  let navigate = useNavigate();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  let classId = params.get("classId");

  //Modal update
  const [openEdit, setOpenEdit] = useState(false);
  const handleOpenEdit = () => setOpenEdit(true);
  const handleCloseEdit = () => setOpenEdit(false);

  //Modal delete
  const [openDel, setOpenDel] = useState(false);
  const handleOpenDel = () => setOpenDel(true);
  const handleCloseDel = () => setOpenDel(false);

  const [deleteExamType] = useMutation(DELETE_EXAM_TYPE, {
    onCompleted: ({ deleteExamType }) => {
      setLoading(false);
      if (deleteExamType?.isSuccess === true) {
        setAlert(true, "success", deleteExamType?.message);
        handleCloseDel();
        setRefetch();
      } else {
        setAlert(true, "error", deleteExamType?.message);
      }
    },
    onError: (error) => {
      console.log("Error", error?.message);
    },
  });

  const handleDelete = () => {
    deleteExamType({
      variables: {
        id: editData?._id,
      },
    });
  };
  return (
    <div>
      <Stack direction="row" justifyContent="right">
        <Tooltip title={t("update")} placement="top">
          <IconButton onClick={handleOpenEdit}>
            <Box className="update-container">
              <MdModeEdit className="update-icon" />
            </Box>
          </IconButton>
        </Tooltip>
        <Tooltip title={t("delete")} placement="top">
          <IconButton onClick={handleOpenDel}>
            <Box className="delete-container">
              <MdDelete className="delete-icon" />
            </Box>
          </IconButton>
        </Tooltip>
      </Stack>

      {openEdit && (
        <ExamTypeForm
          open={openEdit}
          dialogTitle={"Update"}
          editData={editData}
          setRefetch={setRefetch}
          handleClose={handleCloseEdit}
        />
      )}

      {openDel && (
        <DialogDelete
          open={openDel}
          handleClose={handleCloseDel}
          loading={loading}
          deleteTitle={t("modal_title_delete_exam_type")}
          handleDelete={handleDelete}
          editData={editData}
        />
      )}
    </div>
  );
}
